module.exports = __webpack_public_path__ + "img/scb.2d871204.jpg";